/**
 * useActiveMaintenance Hook
 * 현재 활성화된 점검 조회 훅 (협력사용)
 * @description 1분마다 활성 점검 상태를 폴링하여 확인
 */
import { useCallback, useEffect, useState } from 'react';
import { maintenanceApi } from '../api/maintenanceApi';
import { GetActiveMaintenanceResponseDto } from '../types/maintenance.types';

export const useActiveMaintenance = () => {
    const [activeMaintenance, setActiveMaintenance] = useState<GetActiveMaintenanceResponseDto | null>(null);
    const [loading, setLoading] = useState(true);

    const fetchActiveMaintenance = useCallback(async () => {
        try {
            setLoading(true);
            const response = await maintenanceApi.getActiveMaintenance();
            setActiveMaintenance(response);
        } catch {
            setActiveMaintenance(null);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchActiveMaintenance();

        // 1분마다 점검 상태 확인
        const interval = setInterval(fetchActiveMaintenance, 60000);
        return () => clearInterval(interval);
    }, [fetchActiveMaintenance]);

    return {
        activeMaintenance,
        isMaintenance: activeMaintenance?.isMaintenance ?? false,
        loading,
        refetch: fetchActiveMaintenance,
    };
};
